import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const DocumentRoot = ReactDOM.createRoot(document.getElementById('root'));
DocumentRoot.render(
  <App />,
);
